export const SET_NOTIFICATIONS_FEED = 'SET_NOTIFICATIONS_FEED'
export const ADD_NOTIFICATIONS_FEED = 'ADD_NOTIFICATIONS_FEED'
export const SET_NOTIF_VIEWED = 'SET_NOTIF_VIEWED'
export const SET_ALL_VIEWED = 'SET_ALL_VIEWED'
export const SET_UNREAD_COUNT = 'SET_UNREAD_COUNT'
export const ADD_NOTIFS_COUNT = 'ADD_NOTIFS_COUNT'
export const SET_TMPL_NOTIFICATIONS = 'SET_TMPL_NOTIFICATIONS'
